import React from 'react';
import styled from 'styled-components';

export const GlobalContainer: React.FC<{children: React.ReactNode}> = ({ children }) => {
    return (
      <Container>
        {children}
      </Container>
  );
}

const Container = styled.div`
    max-width: 1600px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    padding: 0 25px;
    min-height: 100vh;
    @media (min-width: 768px) {
        padding: 0 30px;
    }
`